import React, { Component } from 'react';
import styled from 'styled-components';
import { t } from 'src/utils/translate';

import Page from 'components/Page';
import BannerImage from 'components/BannerImage';
import ScrollAnimation from 'components/ScrollAnimation';
import Container from 'components/Container';
import List from './elements/List';
import Overlay from './elements/Overlay';

import plans from 'src/data/plans';

const filters = [
  {
    label: t('plans.filters.0'),
    filters: {
      studio: true,
    },
  },
  {
    label: t('plans.filters.1'),
    filters: {
      bed: 1,
    },
  },
  {
    label: t('plans.filters.2'),
    filters: {
      bed: 2,
      den: false,
    },
  },
  {
    label: t('plans.filters.3'),
    filters: {
      bed: 2,
      den: true,
    },
  },
  {
    label: t('plans.filters.4'),
    filters: {
      bed: 3,
      den: false,
    },
  },
  {
    label: t('plans.filters.5'),
    filters: {
      bed: 3,
      den: true,
    },
  },
];

const types = [
  ['tower', t('plans.types.0')],
  ['mid-rise', t('plans.types.1')],
  ['townhome', t('plans.types.2')],
];

class Plans extends Component {
  state = {
    activePlan: null,
    activeType: 'tower',
  };

  handleClickPlan = plan => {
    this.setState({ activePlan: plan });
  };

  handleCloseOverlay = () => {
    this.setState({ activePlan: null });
  };

  handleClickTypeTab = type => {
    this.setState({ activeType: type });
  };

  render() {
    let filteredPlans = plans.filter(plan => {
      return plan.type === this.state.activeType;
    });

    return (
      <Page
        background={require('src/assets/images/floorplans/banner.jpg')}
        banner={<BannerImage />}
      >
        <ScrollAnimation>
          <ComingSoon>
            <h2>{t('plans.heading')}</h2>
          </ComingSoon>
          <Tabs>
            {types.map((type, index) => (
              <Tab
                key={index}
                onClick={() => {
                  this.handleClickTypeTab(type[0]);
                }}
                active={type[0] === this.state.activeType}
              >
                {type[1]}
              </Tab>
            ))}
          </Tabs>
          <ListContainer>
            <List
              type={this.state.activeType}
              plans={filteredPlans}
              filters={filters}
              onClickPlan={this.handleClickPlan}
            />
          </ListContainer>
        </ScrollAnimation>
        <Overlay
          isOpen={!!this.state.activePlan}
          onClickClose={this.handleCloseOverlay}
          plan={this.state.activePlan}
        />
      </Page>
    );
  }
}

const ComingSoon = styled.div`
  text-align: center;
  padding: 100px 20px 50px;
  h2 {
    color: ${({ theme }) => theme.colorPrimary};
    text-transform: uppercase;
    line-height: 1.5;
  }
`;

const ListContainer = styled(Container)`
  padding-bottom: 100px;
  max-width: 900px;
`;

const Tabs = styled.div`
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  margin-bottom: 75px;
`;

const Tab = styled.a`
  position: relative;
  padding: 0 20px;
  font-family: ${props =>
    props.active ? props.theme.fontBold : props.theme.font};
  font-size: 12px;
  letter-spacing: 1.5px;
  cursor: pointer;
  &::after {
    content: '';
    width: 1px;
    height: 125%;
    position: absolute;
    right: 0;
    top: 50%;
    background: #e8e8e8;
    transform: translateY(-60%);
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
`;

export default Plans;



// WEBPACK FOOTER //
// ./src/pages/Plans/Plans.js